var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrbit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1119 1119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M559.555 1116.11C866.932 1116.11 1116.11 866.932 1116.11 559.555C1116.11 252.178 866.932 3 559.555 3C252.178 3 3 252.178 3 559.555C3 866.932 252.178 1116.11 559.555 1116.11Z",
    stroke: "#BDBDBD",
    strokeWidth: 4.36643,
    strokeDasharray: "48.52 48.52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbit1);
export default __webpack_public_path__ + "static/media/orbit1.24af06fa08ea6db5707056e32a350ff7.svg";
export { ForwardRef as ReactComponent };